import React from 'react';
import {GMapInput} from '../maps/gmap'
import { List, Datagrid, TextField, ReferenceField, TabbedForm, DeleteButton, FormDataConsumer, Filter, Pagination,AutocompleteInput,
    EditButton, Edit, FormTab, TextInput, required, NumberInput, CloneButton, RichTextField ,
    Create, ReferenceInput, ArrayInput, SimpleFormIterator, Toolbar, FileField, FileInput, ImageField, ImageInput } from 'react-admin';

import RangeInput from '../common/components/RangeInput';

    const StationFilter = (props) => (
        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn />
            <ReferenceInput label="Site Name" source="track__site" 
            sort={{ field: 'name', order: 'ASC' }} perPage = {10000}
            reference="sites">
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            { props.filterValues.track__site &&
                <ReferenceInput label="Course Name" 
                sort={{ field: 'title', order: 'ASC' }}
                source="track" key={props.filterValues.track__site}
                reference="tracks" filter={{site: props.filterValues.track__site, page_size: 10000}}>
                    <AutocompleteInput optionText="title" />
                </ReferenceInput>
            }
        </Filter>
    );

    const StationPagination = props => <Pagination rowsPerPageOptions={[100, 50, 25, 10]} {...props} />;

export const StationList = props => (
    <List {...props} filters={<StationFilter/>} pagination={<StationPagination />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
            <TextField source="description" />
            <TextField source="code" />
            <TextField source="order" label={"Order in Track"}/>
            <TextField source="score" />
            <ReferenceField source="track" reference="tracks" allowEmpty>
                <TextField source="title" />
            </ReferenceField>
            <TextField source="coordinate.name"  label={"Coordinate"}/>
            <RichTextField  source="riddle.question" label={"Riddle Question"} />
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
            <CloneButton />
        </Datagrid>
    </List>
);

export const StationEdit = props => {
    return (
    <Edit title={<StationTitle />} {...props}>
        <TabbedForm toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <FormTab label="General">
                <TextInput label="Id" source="id" disabled />
                <TextInput source="title" validate={required()} />
                <TextInput multiline source="description" validate={required()} />
                <TextInput source="code" validate={required()} />
                <NumberInput source="order" label={"Order"} validate={required()}/>
                <NumberInput source="score" label={"Score"} />
            </FormTab>
            <FormTab label="Track">
                <ReferenceInput  source="track" reference="tracks" perPage = {10000}
                  sort={{ field: 'title', order: 'ASC' }}>
                    <AutocompleteInput optionText="title" />
                </ReferenceInput>
                <FormDataConsumer>
                    {
                        ({ formData, ...rest }) =>
                        <GMapInput
                            source="coordinate"
                            formData={formData}
                            googleKey=""
                            {...rest}
                        />
                    }
                </FormDataConsumer>
                <RangeInput label="Overlay Opacity" source="opacity" step={0.1} min={0} max={1} />
                <NumberInput step={"0.00001"} source="coordinate.lat" label={"Lat of Station"} validate={required()} />
                <NumberInput step={"0.00001"} source="coordinate.lng" label={"Lng of Station"} validate={required()} />
            </FormTab>
            <FormTab label="Riddle" >
                <TextInput multiline style={{direction: "rtl"}} parse={value => value} source="riddle.question" label={"Question"} resettable />
                <TextInput multiline style={{direction: "rtl"}} source="riddle.correct_answer" label={"Correct Answer"} />
                
                <TextInput source="riddle.image_url" label={"Current Image URL"} />
                <ImageField source='riddle.image_url' label="Current Image" title="Current Image" />
                <ImageInput source="riddle.image" accept="image/*" placeholder={<p>Drag new image or click here</p>}>
                    <ImageField source="riddle.image_url.src" />
                </ImageInput>
                <TextInput source="riddle.video_url" label={"Current Video URL"} />
                <FileField source="riddle.video_url" title="current video" label="current video" />
                <FileInput source="riddle.video" accept="video/*,.mkv" placeholder={<p>Drag new video or click here</p>}>
                    <FileField source="riddle.video_url.src" title="upload video" />
                </FileInput>
                <ArrayInput source="riddle.answers" label={"Answers"}>
                    <SimpleFormIterator>
                        <TextInput multiline style={{direction: "rtl"}} label={"Answer"}/>
                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab>
        </TabbedForm>
    </Edit>
)};


export const StationCreate = props => (
    <Create {...props} title="צור תחנה">
        <TabbedForm>
            <FormTab label="General">
                <TextInput source="title" validate={required()} />
                <TextInput multiline source="description" validate={required()} />
                <TextInput source="code" validate={required()} />
                <NumberInput source="order" label={"Order"} validate={required()}/>
                <NumberInput source="score" label={"Score"} />
            </FormTab>
            <FormTab label="Course">
                <ReferenceInput source="track" reference="tracks" 
                  sort={{ field: 'title', order: 'ASC' }}
                title={"Course"} perPage = {10000}>
                    <AutocompleteInput optionText="title" />
                </ReferenceInput>
                <FormDataConsumer>
                    {
                        ({ formData, ...rest }) =>
                        <GMapInput
                            source="coordinate"
                            searchable
                            formData={formData}
                            googleKey=""
                            {...rest}
                        />
                    }
                </FormDataConsumer>
                <RangeInput label="Overlay Opacity" source="opacity" step={0.1} min={0} max={1} />
                <NumberInput step={"0.00001"} source="coordinate.lat" label={"Lat of Station"} validate={required()}/>
                <NumberInput step={"0.00001"} source="coordinate.lng" label={"Lng of Station"} validate={required()}/>
            </FormTab>
            <FormTab label="Riddle">
                <TextInput multiline style={{direction: "rtl"}} source="riddle.question" label={"Question"} />
                
                <TextInput multiline style={{direction: "rtl"}} source="riddle.correct_answer" label={"Correct Answer"} />
                {props.location.search ? <ImageField source="riddle.image_url" label="Current Image" title="Current Image" /> : null }
                <ImageInput source="riddle.image" accept="image/*" placeholder={<p>Drag image or click here</p>}>
                    <ImageField source="riddle.image_url.src" />
                </ImageInput>
                {/* <TextInput source="riddle.image_url" label={"Image URL"}/> */}
                {props.location.search ? <FileField source="riddle.video_url" title="current video" label="current video" /> : null }
                <FileInput source="riddle.video" accept="video/*,.mkv" placeholder={<p>Drag video or click here</p>}>
                    <FileField source="riddle.video_url.src" title="title" />
                </FileInput>
                {/* <TextInput source="riddle.video_url" label={"Video URL"} /> */}
                <ArrayInput source="riddle.answers" label={"Answers"} {...props}>
                    <SimpleFormIterator {...props}>
                        <TextInput multiline style={{direction: "rtl"}} label={"Answer"}/>
                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab>
        </TabbedForm>
    </Create>
);

const StationTitle = ({ record }) => {
    return <span>Station {record ? `"${record.title}"` : ''}</span>;
};